interface PlayButtonProps {
  className?: string;
}

/** Circular outlined play button matching the RESTORE site treatment. */
export function PlayButton({ className }: PlayButtonProps) {
  return (
    <svg
      viewBox="0 0 100 100"
      role="img"
      aria-hidden="true"
      className={className}
    >
      <circle
        cx="50"
        cy="50"
        r="46"
        fill="rgba(0,0,0,0.35)"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path d="M40 32 L72 50 L40 68 Z" fill="currentColor" />
    </svg>
  );
}

export default PlayButton;
